import { z } from 'zod';

/** Shared validation schemas for the authentication forms. */

export const loginSchema = z.object({
  email: z.email('Please enter a valid email address'),
  password: z.string().min(1, 'Password is required'),
});

export const registrationSchema = z
  .object({
    firstName: z.string().trim().min(1, 'Please enter your first name'),
    lastName: z.string().trim().min(1, 'Please enter your last name'),
    country: z.string().min(2, 'Please select your country'),
    email: z.email('Please enter a valid email address'),
    password: z
      .string()
      .min(8, 'Password must be at least 8 characters')
      .regex(/[A-Za-z]/, 'Password must contain at least one letter')
      .regex(/[0-9]/, 'Password must contain at least one number'),
    confirmPassword: z.string().min(1, 'Please confirm your password'),
    acceptTerms: z
      .boolean()
      .refine((value) => value === true, {
        message: 'You must accept the Terms of Service and Privacy Policy',
      }),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: 'Passwords do not match',
    path: ['confirmPassword'],
  });

export const forgotPasswordSchema = z.object({
  email: z.email('Please enter a valid email address'),
});

export type LoginFormValues = z.infer<typeof loginSchema>;
export type RegistrationFormValues = z.infer<typeof registrationSchema>;
export type ForgotPasswordFormValues = z.infer<typeof forgotPasswordSchema>;
